import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import EmpoweringSustainableGrowth from "./sections/EmpoweringSustainableGrowth";
import BuiltOn20YearsOfFaithFamily from "./sections/BuiltOn20YearsOfFaithFamily";
import OurSpecializedCareServices from "./sections/OurSpecializedCareServices";
import IndustriesServed from "./sections/IndustriesServed";
import TheCreativeVision from "./sections/TheCreativeVision";
import ReadyToGrow from "./sections/ReadyToGrow";
import LetsStartAConversation from "./sections/LetsStartAConversation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <EmpoweringSustainableGrowth />
      <BuiltOn20YearsOfFaithFamily />
      <OurSpecializedCareServices />
      <IndustriesServed />
      <TheCreativeVision />
      <ReadyToGrow />
      <LetsStartAConversation />
      <Footer />
    </div>;
}